<div class="my-5">
  <!-- page-header -->
  <sm-page-header
    [breadcrumb]="breadcrumb"
    [title]="'paa.pages.version_history' | translate: { paa_ref: paaRepository.getNested('response', 'ref') }">
  </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder
      [dataTableObject]="datatableObject"
      [datas]="data"
      [totalRecords]="totalRecords"
      [loading]="loading"></sm-data-table-builder>
    <sm-dialog #dialog [dialog]="paaDialog"></sm-dialog>
  </div>
</div>
